export default "__VITE_ASSET__BmVJBoNC__"